import React, { useState } from 'react';

import { makeUrl, endpoints } from "./endpoints.js";
import { setJWT } from "./storage.js";

import "./Login.scss"

function Login({handleLogin}) {
  const defaultFormData = {Username: "", Password: ""};
  const [formData, setFormData] = useState(defaultFormData);
  const [badLogin, setBadLogin] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    fetch(makeUrl(endpoints.postToken), {method: 'POST', body: JSON.stringify(formData)})
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        setJWT(data["Token"]);
        setFormData(defaultFormData)
        handleLogin();
      })
      .catch(() => {
        setBadLogin(true);
      });
  }

  return (
    <div className="block">
      <form action="" className="box">
        <div className="field">
          <label className="label">Username</label>
          <input
            className="input"
            type="text"
            name="Username"
            placeholder="Username"
            value={formData.Username}
            onChange={handleChange}
          />
        </div>
        <div className="field">
          <label className="label">Password</label>
          <input
            className="input"
            type="Password"
            name="Password"
            placeholder="Password"
            value={formData.Password}
            onChange={handleChange}
          />
        </div>
        <div className="field">
          <button className="button honey-button" onClick={handleSubmit}>Login</button>
        </div>
        {badLogin &&
          <div className="block">
            <div className="notification honey-bad-login">
              Wrong password
            </div>
          </div>
        }
      </form>
    </div>
  );
}

export default Login;
